/* Reuse the theme's Boulevard instance. Never load a second widget or analytics tag. */
(() => {
  if (window.omniIvHubInstalled) return;
  window.omniIvHubInstalled = true;
  const paths = {
  "myers": "/cart/menu/IV%20Infusion%20Therapy/s_55669018-191f-4c43-9cbe-d5ee662d7a9d",
  "immune": "/cart/menu/IV%20Infusion%20Therapy/s_4831bad1-5fc9-4783-9913-a009ed544ea2",
  "athlete": "/cart/menu/IV%20Infusion%20Therapy/s_e5d5dbe3-2b5d-4fb6-aeb0-f46da82f349a",
  "detox": "/cart/menu/IV%20Infusion%20Therapy/s_ae66eafd-7bbb-42c0-a112-c8a31517abdb",
  "hangover": "/cart/menu/IV%20Infusion%20Therapy/s_667c2c8c-5abb-4ed6-bd94-3018418bc3ae",
  "glow": "/cart/menu/IV%20Infusion%20Therapy/s_feb1cb66-3a1d-4be7-ba4c-769a84198929",
  "menu": "/cart/menu/IV%20Infusion%20Therapy"
};
  let opening = false;
  const delay = ms => new Promise(resolve => window.setTimeout(resolve, ms));
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-omni-iv-book]');
    if (!button || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (opening) return;
    const path = paths[button.dataset.omniIvBook];
    if (!path) return;
    const status = button.closest('.omni-iv-booking').querySelector('.omni-iv-booking-status');
    opening = true;
    button.setAttribute('aria-busy', 'true');
    status.hidden = false;
    status.textContent = 'Opening appointment options...';
    try {
      for (let i = 0; i < 40; i++) {
        if (typeof window.blvd?.openBookingWidget === 'function') break;
        await delay(250);
        if (!button.isConnected) return;
      }
      if (typeof window.blvd?.openBookingWidget !== 'function') throw new Error('Booking unavailable');
      // Reuse the service paths already configured in Omni's Boulevard integration.
      await window.blvd.openBookingWidget({ urlParams: {
        locationId: '4f404d0e-4624-4888-a222-e1a83e71d4ba',
        visitType: 'SELF_VISIT', path
      }});
      status.hidden = true;
    } catch (_) {
      status.textContent = 'Booking could not open. Please call ';
      const phone = document.createElement('a');
      phone.href = 'tel:+17203131510';
      phone.textContent = '(720) 313-1510';
      status.append(phone, document.createTextNode(' and our team can help.'));
    } finally {
      opening = false;
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('shopify:block:select', event => {
    const faq = event.target.closest('.omni-iv-faq');
    if (faq) faq.open = true;
  });
})();